module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }